import { connect } from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
// import 'bootstrap/dist/css/bootstrap.css'
import React, { useEffect, useState } from "react";
import DatatableComponent from "../../helpers/DatatableComponent";
import BasicMenu from "../../helpers/menu";
import FormDialog from "../../helpers/FormDialog";
import moment from "moment";
import {
  Badge,
  Paper,
  Box,
  Button,
  Typography,
  TableContainer,
} from "@mui/material";
import DeleteDialog from "../../helpers/DeleteDialog";
import { useHistory } from "react-router";
import StatusLayout from "components/Status";

const versions = [
  {
    label: "Both",
    value: "both",
  },
  {
    label: "Mobile",
    value: "mobile",
  },
  {
    label: "Web",
    value: "web",
  },
];
function VmsManagement({ location, SetSelectedMenu }) {
  const [open, setOpen] = React.useState(0);
  const [value, setValue] = React.useState({});
  const [list, setList] = React.useState([]);
  const [id, setId] = React.useState();
  const [count, setCount] = React.useState(0);
  const [selected, setSelected] = React.useState(
    location.state?.status ?? "all"
  );
  const [deleteOpen, setDeleteOpen] = React.useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [dateFilterApplied, setDateFilterApplied] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);

  const history = useHistory();

  useEffect(() => {
    setSelected(location.state?.status ?? "all");
  }, [location.state]);

  useEffect(() => {
    SetSelectedMenu({
      menu: "product",
      title: "Product Management",
    });
  }, []);

  const handleFromDateChange = (e) => {
    setFromDate(e.target.value);
  };

  const handleToDateChange = (e) => {
    setToDate(e.target.value);

    if (fromDate && e.target.value) {
      setDateFilterApplied(true);
      setCount((v) => v + 1); // Trigger data reload
    }
  };

  const clearDateFilter = () => {
    setFromDate("");
    setToDate("");
    setDateFilterApplied(false);
    setCount((v) => v + 1); // Trigger data reload
  };

  const buildUrlWithFilters = () => {
    let url = `/api/vms/list?status=${selected}&count=${count}`;
    if (dateFilterApplied && fromDate && toDate) {
      url += `&fromDate=${fromDate}&toDate=${toDate}`;
    }
    return url;
  };

  const processData = (data) => {
    let filteredData = data.data;

    if (dateFilterApplied && fromDate && toDate) {
      const from = new Date(fromDate);
      const to = new Date(toDate);
      to.setHours(23, 59, 59);

      filteredData = data.data.filter((item) => {
        const registrationDate = new Date(item.registrationDate);
        return registrationDate >= from && registrationDate <= to;
      });

      data = {
        ...data,
        data: filteredData,
      };
    }

    setList(filteredData);
    setTotalRecords(data.totalRecords); // Set total records count
    return data;
  };

  const columns = [
    {
      name: "version",
      label: "Version",
      options: {
        customBodyRender: (v) => versions.find((x) => x.value === v)?.label,
      },
    },
    {
      name: "registrationDate",
      label: "Registration Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => moment(value).format("DD/MM/yyyy") ?? "",
      },
    },
    {
      name: "clientName",
      label: "Client",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "totalUsers",
      label: "Users",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (b) => b?.toLocaleString(),
      },
    },
    {
      name: "pricePerUse",
      label: "Price per Use",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (b) => b?.toLocaleString(),
      },
    },
    {
      name: "id",
      label: "Total",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (b) => {
          const obj = list.find((v) => v.id === b);

          if (!obj) {
            return "";
          }

          return (obj.pricePerUse * obj.totalUsers)?.toLocaleString();
        },
      },
    },
    {
      name: "paymentStatus",
      label: "Payment Status",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (status) => {
          return <StatusLayout status={status} />;
        },
      },
    },
    {
      name: "id",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (v) => (
          <BasicMenu
            onDetails={() => history.push(`/admin/vms/clients/${v}`)}
            extra={[
              {
                label: "Document",
                onClick: () =>
                  history.push(`/admin/product/documents/${v}/vmsId`),
              },
            ]}
            onDelete={() => {
              setDeleteOpen(true);
              setId(v);
            }}
            onEdit={() => {
              setOpen(2);
              const obj = list.find((vx) => vx.id === v);
              setId(v);
              setValue0("version", obj.version);
              setValue0(
                "registrationDate",
                moment(obj.registrationDate).format("YYYY-MM-DD")
              );
              setValue0("clientName", obj.clientName);
              setValue0("users", obj.users);
              setValue0("pricePerUse", obj.pricePerUse);
              setValue0("paymentStatus", obj.paymentStatus);
            }}
          />
        ),
      },
    },
  ];
  const setValue0 = (name, val) => {
    if (!name) {
      return null;
    }

    setValue((v) => {
      v[name] = val;
      return { ...v };
    });
  };
  const onSuccess = () => setCount((v) => v + 1);

  return (
    <div className="w-full mb-12 px-4">
      <DeleteDialog
        open={deleteOpen}
        setOpen={() => setDeleteOpen(false)}
        onSuccess={onSuccess}
        url={`/api/vms/delete/${id}`}
      />
      <FormDialog
        col={6}
        open={open > 0}
        onSuccess={onSuccess}
        setOpen={setOpen}
        url={open === 1 ? "/api/vms/create" : `/api/vms/update/${id}`}
        title={
          open === 1 ? "Create New VMS Institution" : "Edit VMS Institution"
        }
        fields={[
          {
            name: "version",
            label: "Version",
            value: value["version"],
            required: false,
            type: "select",
            values: versions,
            setValue: (val) => setValue0("version", val),
          },
          {
            name: "registrationDate",
            label: "Registration Date",
            type: "date",
            value: value["registrationDate"],
            required: true,
            setValue: (val) => setValue0("registrationDate", val),
          },
          {
            name: "clientName",
            label: "Client Name",
            type: "text",
            value: value["clientName"],
            required: true,
            setValue: (val) => setValue0("clientName", val),
          },
          {
            name: "pricePerUse",
            label: "Price Per Use",
            value: value["pricePerUse"],
            required: false,
            type: "number",
            setValue: (val) => setValue0("pricePerUse", val),
          },
          {
            name: "paymentStatus",
            label: "Payment Status",
            type: "select",
            value: value["paymentStatus"],
            values: [
              {
                label: "Payment Pending",
                value: "pending",
              },
              {
                label: "Invoice submitted",
                value: "submitted",
              },
              {
                label: "Paid",
                value: "paid",
              },
            ],
            setValue: (val) => setValue0("paymentStatus", val),
          },
        ]}
      />
      <DatatableComponent
        order={location.state?.order}
        onRowClick={(data, { rowIndex }) => {
          history.push(`/admin/vms/clients/${list[rowIndex].id}`);
        }}
        onAddNew={() => setOpen(1)}
        totalRecords={totalRecords}
        processData={processData}
        elevation={1}
        columns={columns}
        url={buildUrlWithFilters()}
        title={
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              alignItems: "center",
            }}
          >
            <span>
              VMS Institutions{" "}
              {location.state?.status
                ? `(Status: ${location.state?.status})`
                : ""}
            </span>

            <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
              <div className="md:w-full w-1/6 mb-2 xl:mb-0">
                <Paper
                  component="form"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    width: "80%",
                    border: "none",
                    boxShadow: "none",
                  }}
                >
                  <label
                    style={{
                      minWidth: "80px",
                      maxWidth: "80px",
                      textAlign: "center",
                    }}
                    className="min-w-24 text-[#9295AB] text-ml px-3 py-1 font-light placeholder-blueGray-300 text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  >
                    FROM
                  </label>

                  <input
                    className="px-3 py-1 placeholder-blueGray-300 border-5 text-blueGray-600 bg-gray rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    type="date"
                    value={fromDate}
                    onChange={handleFromDateChange}
                    max={toDate}
                  />
                </Paper>
              </div>

              <div className="md:w-full w-1/6 mb-2 xl:mb-0">
                <Paper
                  component="form"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    width: "80%",
                    border: "none",
                    boxShadow: "none",
                  }}
                >
                  <label
                    style={{
                      minWidth: "80px",
                      maxWidth: "80px",
                      textAlign: "center",
                    }}
                    className="min-w-24 text-[#9295AB] text-ml px-3 py-1 font-light placeholder-blueGray-300 text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  >
                    TO
                  </label>

                  <input
                    className="px-3 py-1 placeholder-blueGray-300 border-5 text-blueGray-600 bg-gray rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    type="date"
                    value={toDate}
                    onChange={handleToDateChange}
                    min={fromDate}
                  />
                </Paper>
              </div>

              {dateFilterApplied && (
                <Button
                  variant="outlined"
                  size="small"
                  onClick={clearDateFilter}
                >
                  Clear
                </Button>
              )}
            </Box>
          </Box>
        }
      />
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(VmsManagement);
